import {CustomerRequest} from './customer-request';
import {PropertyRequest} from './property-request';
import {TaskRequest} from '../task-request';
import { NationalityNoteRequest } from '../nationality-note-request';
import { OfficeRequest } from '../office-request';
import { VendorRequest } from './vendor-request';
import { ListingRepresentativeRequest } from './listing-representative-request';
import { Company } from '../../response/prospect/company';
import { CompanyRequest } from './company-request';
import { ContractChecklist } from '../../response/contract-checklist';
import { ContractChecklistRequest } from '../contract-checklist-request';
import { MarketingRequest } from './marketing-request';
import { TenantRequest } from './tenant-request';
import {AddressRequest} from '../address/address-request';

import {GrannyFlatLink} from './granny-flat-link';

export class ProspectRequest {
  grannyFlatLink?: GrannyFlatLink;
  prospectId?: number;
  note?: string;
  motiveNote?: string;
  call?: boolean;
  sms?: boolean;
  door?: boolean;
  mail?: boolean;
  rate?: number;
  loanAmount?: number;
  hiddenBankRate?: number;
  clearLoanAmount?: boolean;
  clearHiddenBankRate?: boolean;
  createdBy?: string;
  createdDate?: number;
  customer?: CustomerRequest;
  property?: PropertyRequest;
  userId?: number;
  categoryIds?: number[];
  nationalityNote?: NationalityNoteRequest;
  office?: OfficeRequest;
  officeId?: number;
  vendors?: VendorRequest[];
  listingRepresentative?: ListingRepresentativeRequest;
  solicitorCompanyId?: number;
  historyNote?: string;
  contractRequestDate?: number;
  contractReceivedDate?: number;
  contractChecklist?: ContractChecklistRequest[];
  marketing?: MarketingRequest;
  tenant?: TenantRequest;
  addressId?: number;
  address?: AddressRequest;

  multipleAddress?: AddressRequest[];

  static getDummy = () => {
    return {
      prospectId: '',
      grannyFlatLink: null,
      note: '',
      motiveNote: '',
      call: '',
      sms: '',
      door: '',
      mail: '',
      rate: '',
      loanAmount: '',
      hiddenBankRate: '',
      clearLoanAmount: '',
      clearHiddenBankRate: '',
      createdBy: '',
      createdDate: '',
      customer: '',
      property: '',
      address: '',
      nationalityNote: '',
      office: '',
      vendors: '',
      listingRepresentative: '',
      solicitorCompanyId: '',
      historyNote: '',
      contractRequestDate: '',
      contractReceivedDate: '',
      contractChecklist: '',
      marketing: '',
      tenant: '',
    };
  }

  static getBlankRequestForMultiUpdate = () => {
    return {
      prospectIds: [],
      motiveNote: null,
      note: null,
      call: false,
      sms: false,
      door: false,
      mail: false,
      rate: null,
      createdBy: null,
      createdDate: null,
      customer: {
        customerId: null,
        name: null,
        surname: null,
        phone: null,
        mobilePhone: null,
        relationship: null,
        motivate: null,
        isDirector: false,
        isInfluencer: false,
        isSocialble: false,
        isConcensious: false,
        motivateFinancialUp: false,
        motivateFinancialDown: false,
        motivateLifestyleUp: false,
        motivateLifestyleDown: false,
        email: null,
        facebook: null,
        instagram: null,
        dob: null,
        nationality: null,
        anniversaryDay: null,
        religion: null,
        profesion: null,
        language: null,
        note: null,
        callbackDate: null,
        link: null,
        parentType: null,
        abnNumber: null,
        gstRegistered: false,
        customerAdditionalInfo: [],
        age: null,
        numberOfKids: null,
        marriedStatus: null,
        loanAmount: null,
        hiddenBankRate: null,
      },
      property: {
        propertyId: null,
        type: null,
        bed: null,
        bath: null,
        car: null,
        land: null,
        sell: false,
        rent: false,
        otm: false,
        vac: false,
        buyer: null,
        tenant: null,
        sold: false,
        underContract: false,
        leased: false,
        sellPrice: null,
        rentPrice: null,
        askingPrice: null,
        otmDate: null,
        vacDate: null,
        purchaseDate: null,
        enqDate: null,
        link: null,
        askingPriceFrom: null,
        askingPriceTo: null,
        agentEstimatePriceFrom: null,
        agentEstimatePriceTo: null,
        inclusions: null,
        methodOfSale: null,
        agreementDate: null,
        agencyPeriodFrom: null,
        agencyPeriodTo: null,
        commissionRate: null,
        vpaTotal: null,
        vpaList: [],
        listingStatus: null,
        agreementType: null,
        adjustment: null,
        agentGroups: [],
        openHomeTime: null,
        beingFurnished: false,
        managementFee: null,
        administrationFee: null,
        sellCompanyId: null,
        rentCompanyId: null,
        officeId: null,
      },
      office: {
        officeId: null,
        officePropertyId: null,
        name: null,
        address: null,
        phone: null,
        description: null,
        status: null,
        createdDate: null,
        createdBy: null,
        officeProperty: {
          officePropertyId: null,
          officeId: null,
          propertyType: null,
          buyerType: null,
          minBuyPrice: null,
          maxBuyPrice: null,
          minRentalPrice: null,
          maxRentalPrice: null,
          infoVisible: false,
          defaultDailyGoal: null,
        },
      },
      vendors: [],
      listingRepresentative: null,
      historyNote: null,
      contractRequestDate: null,
      contractReceivedDate: null,
      contractChecklist: [],
      marketing: null,
      tenant: {
        tenantId: null,
        name: null,
        surname: null,
        phone: null,
        mobilePhone: null,
        email: null,
        agreement: null,
        createdDate: null,
        createdBy: null,
        isArrear: false,
        arrearAmount: null,
        arrearWeekCount: null,
        isMaintenance: false,
        maintenanceNote: null,
        notificationSent: false,
        startDate: null,
        endDate: null,
      },
      address: {
        addressId: null,
        number: null,
        unit: null,
        streetId: null,
        longitude: null,
        latitude: null,
        formattedAddress: null,
        numberFrom: null,
        numberTo: null,
        numberUnit: null,
        numberFromLetter: null,
        numberToLetter: null,
        additionalInfo: null,
        officeId: null,
      },
      nationalityNote: null,
      categoryIds: [],
      officeId: null,
      userId: null,
    };
  }
}
